import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableDataCellComponent } from './table-data-cell.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TableDataCellComponent],
})
export class TableDataCellModule {}
